var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getIn, useFormikContext } from "formik";
import React from "react";
import { UrlViewInput } from "../components";
export const FormikUrlTextField = (_a) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    const formik = useFormikContext();
    const error = getIn(formik.errors, name);
    const handleBlur = () => {
        formik.setFieldTouched(name, true);
    };
    const touched = getIn(formik.touched, name);
    const _value = getIn(formik.values, name);
    return (React.createElement(UrlViewInput, Object.assign({ onChange: (e) => formik.setFieldValue(name, e === null || e === void 0 ? void 0 : e.target.value), value: _value, error: touched && !!error, errorText: touched ? error : "", onBlur: handleBlur }, props)));
};
//# sourceMappingURL=FormikUrlTextField.js.map